import { render, staticRenderFns } from "./createReason.vue?vue&type=template&id=07b39436&scoped=true&"
import script from "./createReason.vue?vue&type=script&lang=js&"
export * from "./createReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b39436",
  null
  
)

export default component.exports